"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var GoHomeButtonStyles_1 = require("./GoHomeButtonStyles");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var ContinueButton_1 = require("../../../../common/components/continueButton/ContinueButton");
var GoHomeButton = function (_a) {
    var homePageURL = _a.homePageURL, myAccountDxpIntegration = _a.myAccountDxpIntegration;
    var style = GoHomeButtonStyles_1.default();
    var redirectToHomePage = react_1.useCallback(function () {
        window.location.href = homePageURL;
    }, [homePageURL]);
    return (<core_1.Box className={myAccountDxpIntegration ? style.buttonWrapperWithMyAccount : style.buttonWrapper}>
      <ContinueButton_1.default className={style.button} testId={'button:confirmation:redirectHome'} withIcon={true} onClick={redirectToHomePage}>
        <Translation_1.default className={style.buttonText} id={'trans__checkout__confirmation_page__home_page_button'}/>
      </ContinueButton_1.default>
    </core_1.Box>);
};
exports.default = GoHomeButton;
